// toggle .visible on the form with a click on the button id="newsletter-button"

const newsletterToggle = document.querySelector('[aria-controls="newsletter-form"]')

newsletterToggle.addEventListener('click', () => {
  const newsletterOpened = newsletterToggle.getAttribute('aria-expanded')

  if (newsletterOpened === 'false') {
    newsletterToggle.setAttribute('aria-expanded', true)
  } else {
    newsletterToggle.setAttribute('aria-expanded', false)
  }
})
